import { Component, OnChanges, OnInit, inject, ChangeDetectionStrategy, input, output } from '@angular/core';
import {GuruEntity} from '../../../model/guru-entity';
import {ModelService} from '../../../services/model-service';
import {SelectionUtils} from '../../selection-utils';
import {ConfigurationSection, UserStateService} from '../../../services/user-state.service';
import { FormsModule } from '@angular/forms';

import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'app-modular-quick-primary-valve-package',
    templateUrl: './modular-quick-primary-valve-package.component.html',
    styleUrls: ['./modular-quick-primary-valve-package.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatIcon, FormsModule]
})
export class ModularQuickPrimaryValvePackageComponent implements OnChanges {
  private modelService = inject(ModelService);
  private userStateService = inject(UserStateService);


  readonly invalidEntities = input.required<string[]>();
  readonly engineKey = input.required<string>();
  readonly selectionEntities = input.required<GuruEntity[]>();
  readonly valueChanged = output<void>();
  valveSizeSelection!: GuruEntity;
  flowControlTypeSelection!: GuruEntity;
  controlValveSelection!: GuruEntity;
  isolationBallValveSelection!: GuruEntity;
  isExpanded = true;
  private sectionKey = ConfigurationSection.PRIMARY_VALVE_PACKAGE;

  constructor() {
    this.isExpanded = !this.userStateService.isConfigurationSectionCollapsed(this.sectionKey);
  }

  ngOnChanges(): void {
    this.valveSizeSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USPrimaryValveSize');
    this.flowControlTypeSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USPrimaryFlowCntl');
    this.controlValveSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USPrimaryControlValve');
    this.isolationBallValveSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USPrimaryIsolationBallValve');
  }

  selectionChanged(entity: GuruEntity, newValue: string): void {
    this.modelService.setValue(entity.Name, this.engineKey(), newValue).subscribe(() => this.valueChanged.emit());
  }

  toggleExpansion(): void {
    this.isExpanded = !this.isExpanded;
    this.userStateService.setCollapsedValue(this.sectionKey, this.isExpanded);
  }

  getExpansionIcon(): string {
    return this.isExpanded ? 'arrow_drop_up' : 'arrow_drop_down';
  }

  isInvalidSelection(entityName: string) {
    return this.invalidEntities() && this.invalidEntities().indexOf(entityName) >= 0;
  }

}
